import {Signal} from '../signals-screen/types';
import {SelectBrandItem} from '../../services/dashboard.service';
import {DeviceFilterType} from '../../services/types';
import {DateRangeValue} from '../../utils/time';

export type HistoryMessage = {
  role: string;
  content: string;
}

export type FocusArea = {
  title: string;
  subQuestions: string[];
}

export type FocusAreasMap = Record<string, { subQuestions: string[] }>;

export type WizardPayload = {
  type: string;
  focusAreas: Record<string, FocusArea>;
  brands: string[];
  competitors: string[];
  geos: string[];
  startDate: string;
  endDate: string;
};

export type AlertPayload = {
  alert_type: string;
  metric: string;
  change: {
    direction: string;
    percent: string;
  };
  date_before: string;
  date_after: string;
  brand_key: string;
}

export type WidgetContext = {
  name?: DashboardWidget;
  metrics: string[];
  myBrand: string;
  myCompetitors: string[];
  dateRange: DateRangeValue;
  countries: string[];
  device: DeviceFilterType;
}

export type CopilotMessagePayload = {
  requestId: string;
  userPrompt: string;
  sessionContext: {
    sessionId: string;
    customerName: string;
    customerBrandsList: string[];
  };
  workflowContext?: string;
  conversationHistory: HistoryMessage[];
  agencyId: string;
  debug?: boolean;
  wizard?: WizardPayload;
  alert?: AlertPayload;
  signal?: Signal;
  widgetContext?: WidgetContext;
}

export type CopilotMessageResponse = {
  requestId: string;
  sessionId: string;
  userId: string;
  status: string;
  timestamp: string;
  answer: {
    text: string;
    insights: string;
  };
  graph: graphSpec[];
  followUpQuestions: string[];
  creativesURLs: string[];
  originalResponse?:any;
  lambdaId?: string;
}

export type Wizard = {
    type:  string;
    focusAreas: FocusAreasMap;
    title: string;
    description: string;
    tileSvg: string;
    wizardSvg: string;
}

export type graphSpec = {
  title: string;
  type: 'bar'| 'line' | 'doughnut';
  url?: string;
  x: string[];
  series: graphSeries[];
  y_is_percentage?: boolean;
  x_axis: string;
  y_axis: string;
}

export type graphSeries = {
  name: string;
  y: number[];
  unit?: string;
}

export enum DashboardWidget {
  SPEND_ANALYSIS = 'Spend Analysis',
  CREATIVE_GALLERY = 'Creative Gallery',
}

export const WIDGET_QUESTIONS_MAP = {
  [DashboardWidget.SPEND_ANALYSIS]: [
    "How does my spend efficiency compare against industry benchmarks?",
    "How can I scale my campaign CTR success, based on my competitions strategies?",
    "Where am I seeing the biggest gaps in efficiency vs. my competitors?",
    "What are the biggest drivers of inefficient spend in my current dataset?"
  ],
  [DashboardWidget.CREATIVE_GALLERY]: [
    "What are my most effective creatives based on CTR, TruAttention™, and impressions?",
    "What can I do to improve my creative effectiveness based on the competition?",
    "What factors are contributing to the success of my top creatives?"
  ]
}

export const ASK_POLARIS_SIDE_DRAWER_WIDTH = '700px';
